import React from "react";
import { PiCheck } from "react-icons/pi";
import { Link } from "react-router-dom";

import { CERTIFICATES_PAGE, DASHBOARD_PAGE, QUALIFICATION_HISTORY_PAGE } from "../../../../constants";
import useNavigationStore from "../../../../stores/navigationStore";
import BootstrapSVG from "../../../BootstrapSVG";

function NavItems() {
  const currentPage = useNavigationStore((s) => s.currentPage);

  return (
    <ul className="list-unstyled d-flex flex-column gap-2">
      <li>
        <Link
          to="/dashboard/create-bill-of-material/"
          className={`btn icon-btn justify-content-start main-sidebar__nav-item ${currentPage === DASHBOARD_PAGE ? "main-sidebar__nav-item--active" : ""}`}
        >
          <BootstrapSVG iconName="house" />
          Home
        </Link>
      </li>
      <li>
        <Link
          to="/dashboard/"
          className={`btn icon-btn justify-content-start main-sidebar__nav-item ${currentPage === QUALIFICATION_HISTORY_PAGE ? "main-sidebar__nav-item--active" : ""}`}
        >
          <PiCheck />
          Qualification History
        </Link>
      </li>
      <li>
        <Link
          to="/dashboard/certificate-of-origin/"
          className={`btn icon-btn justify-content-start main-sidebar__nav-item ${currentPage === CERTIFICATES_PAGE ? "main-sidebar__nav-item--active" : ""}`}
        >
          <BootstrapSVG iconName="file-text" />
          Certificates
        </Link>
      </li>
    </ul>
  );
}

export default NavItems;
